export const parseContentBody = content => {
  if (content) {
    try {
      const result = JSON.parse(content)
      return result?.body?.toString()
    } catch (error) {
      console.error(error)
    }
  }
}

export const displayShowMore = (content, referenceElement) => {
  const parsedContent = parseContentBody(content)

  return _displayShowMoreReturn(parsedContent, referenceElement)
}

export const displaySharedShowMore = (content, referenceElement) => {
  const parsedContent = parseSharedContentBody(content)

  return _displayShowMoreReturn(parsedContent, referenceElement)
}

export const displayMultilineShowMore = (referenceElement: any) => {
  const el = referenceElement?.current
  return el?.scrollHeight > el?.clientHeight
}

export const _displayShowMoreReturn = (html: string, referenceElement) => {
  const count = countNewlines(html)

  return displayMultilineShowMore(referenceElement) || count > 1
}

export const countNewlines = (html = '') => {
  const divs = Math.max(0, html.split('</div>')?.length - 1 || 0)
  const brs = Math.max(0, html.split('<br>')?.length - 1 || 0)

  return divs + brs
}

export const parseSharedContentBody = content => {
  if (content) {
    return content?.toString()
  }
}

export const usePost = () => {
  return {
    parseContentBody,
    displayShowMore,
    displaySharedShowMore,
    displayMultilineShowMore,
    parseSharedContentBody
  } as const
}
